import { render, staticRenderFns } from "./ModalPhoto.vue?vue&type=template&id=994a083a&scoped=true&"
import script from "./ModalPhoto.vue?vue&type=script&lang=js&"
export * from "./ModalPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ModalPhoto.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalPhoto.vue?vue&type=style&index=1&id=994a083a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994a083a",
  null
  
)

export default component.exports